import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Configuration API - Base definition
 *
 * This is the base API slice for the Configuration service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see companyEndpoints.ts - Company management
 * @see centerEndpoints.ts - Center management
 * @see physicianEndpoints.ts - Physician management and upload/download
 * @see payerEndpoints.ts - Payer management and upload/download
 * @see serviceEndpoints.ts - Service management and upload/download
 * @see procedureEndpoints.ts - Procedure management and upload/download
 * @see roomEndpoints.ts - Room management
 * @see approvalConfigEndpoints.ts - Refund/Writeoff approval configuration
 */
export const configurationApi = createApi({
  reducerPath: 'configurationApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.configuration),
  tagTypes: [
    'Company',
    'Center',
    'Centers',
    'Physician',
    'Physicians',
    'Payers',
    'Services',
    'Procedures',
    'Rooms',
    'RefundApproval',
    'WriteoffApproval',
    'PhysicianGroupList',
    'PhysicianGroup',
    'PhysicianGroupMembers',
  ],
  endpoints: () => ({}),
});
